import { render, staticRenderFns } from "./NoVipModal.vue?vue&type=template&id=93790038&scoped=true"
import script from "./NoVipModal.vue?vue&type=script&lang=js"
export * from "./NoVipModal.vue?vue&type=script&lang=js"
import style0 from "./NoVipModal.vue?vue&type=style&index=0&id=93790038&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93790038",
  null
  
)

export default component.exports